<template>
  <div class="drawer-content-page" v-if="init">
    <div class="header-nav">
      <div class="container">
        <div class="row justify-content-between align-items-center mb-2">
          <div class="col-auto">
            <router-link class="back-to-list-link" :to="{ name: 'ClosetDrawerList' }">
              <Icon name="chevron-left" size="24" />
            </router-link>
          </div>

          <div class="col-auto">
            <div class="row no-gutters align-items-center">
              <span class="drawer-name">
                <div class="row align-items-center no-gutters">
                  <!-- <div class="col-auto">
                    <b-icon icon="archive"></b-icon>
                  </div> -->
                  <div class="col-auto">
                    {{ drawerName }}
                  </div>
                </div>
              </span>
            </div>
          </div>

          <div class="col-auto" v-if="showToolsDiv">
            <div class="row align-items-center no-gutters">
              <!-- <div class="col-auto px-1" v-if="hasCloth">
                <a href="#" @click.prevent="importBtnClicked">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.5 9.5L12 12M12 12L14.5 9.5M12 12L12 5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div>

              <div class="col-auto px-1" v-if="hasCloth">
                <a href="#" @click.prevent="exportBtnClicked">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#4D4D4D" stroke-width="1.8"/>
                    <path d="M9.5 5.5L12 3M12 3L14.5 5.5M12 3L12 10" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div> -->

              <div class="col-auto px-1">
                <b-dropdown variant="link" toggle-class="more-option-btn" right no-caret>
                  <template #button-content>
                    <Icon name="More" size="24" />
                  </template>
                  <b-dropdown-item-button @click="importBtnClicked">
                    <div class="row no-gutters align-items-center justify-content-start">
                      <div class="col-auto">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.5 9.5L12 12M12 12L14.5 9.5M12 12L12 5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="col-auto pl-2">
                        移入
                      </div>
                    </div>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="exportBtnClicked" v-if="hasCloth">
                    <div class="row no-gutters align-items-center justify-content-start">
                      <div class="col-auto">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#4D4D4D" stroke-width="1.8"/>
                          <path d="M9.5 5.5L12 3M12 3L14.5 5.5M12 3L12 10" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="col-auto pl-2">
                        移出
                      </div>
                    </div>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="openChangeNameModal">
                    <div class="row no-gutters align-items-center justify-content-start">
                      <div class="col-auto">
                        <Icon name="edit" size="22"/>
                      </div>
                      <div class="col-auto pl-2">
                        編輯
                      </div>
                    </div>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="openDeleteConfirmModal">
                    <div class="row no-gutters align-items-center justify-content-start text-danger">
                      <div class="col-auto">
                        <icon name="delete" size="22"></icon>
                        <!-- <b-icon icon="trash"></b-icon> -->
                      </div>
                      <div class="col-auto pl-2">
                        刪除
                      </div>
                    </div>
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>

        <ClothCategoryTabs v-if="hasCloth" :srcCloths="clothInDrawer" @set="setCategoryFilter" hide-empty-tabs></ClothCategoryTabs>
      </div>
    </div>

    <div class="body-cloths">
      <div class="container">
        <ClothCardList
          v-if="hasCloth"
          ref="cardList"
          :cloths="clothInDrawer"
          :filters="filters"
          :sortType="sortType"
          :sortDirectionDesc="sortDirectionDesc"
          :mode="clothListMode"
          :selectedIds="selectedClothIds"
          :showTitle="blockShowText"
          @clothClicked="clothClicked">
        </ClothCardList>

        <div class="empty-msg" v-if="clothInDrawer.length === 0">
          <p class="text-center">
            還沒有衣服在這個抽屜裡喔！
          </p>

          <b-button variant="outline-primary" @click="openImportModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.5 9.5L12 12M12 12L14.5 9.5M12 12L12 5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            選取單品
          </b-button>
        </div>
      </div>
      <div class="export-confirm-div" :class="{'selection-empty': selectedClothIds.length === 0}" v-if="showExportConfirmDiv">
        <button class="confirm-btn" @click="exportConfirmBtnClicked">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#4D4D4D" stroke-width="1.8"/>
            <path d="M9.5 5.5L12 3M12 3L14.5 5.5M12 3L12 10" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="cancel-btn" @click="exportCancelBtnClicked">
          取消
        </button>
      </div>
    </div>

    <!-- 移入單品的視窗 -->
    <Transition name="fade">
      <DrawerImportModal v-if="showDrawerImportModal" :cloths="importModalCloths" :drawerSerial="drawer.serial" @moved="clothMoved" @back="closeImportModal" @skip="closeImportModal">
      </DrawerImportModal>
    </Transition>

    <!-- 選擇移出的目的地 -->
    <DrawerSelectBottomModal v-if="showMoveToModal" :exceptSerials="[drawer.serial]" @close="closeMoveToModal" @confirm="moveCloths"></DrawerSelectBottomModal>

    <!-- 刪除抽屜確認 -->
    <transition name="fade">
      <WcCommonModal v-if="showDeleteConfirmModal" title="刪除確認" @close="closeDeleteConfirmModal" @cancel="closeDeleteConfirmModal" @backClick="closeDeleteConfirmModal" @ok="deleteDrawer">
        <p>確定要刪除抽屜【{{ drawerName }}】嗎?</p>
      </WcCommonModal>
    </transition>

    <!-- 修改編輯抽屜 -->
    <WcBottomModal v-if="showChangeNameModal" :confirmDisabled="changeNameDisabled" @confirm="editDrawer" @backClick="closeChangeNameModal" @close="closeChangeNameModal">
      <div class="container">
        <b-form-input class="py-3 mt-3 mb-4" v-model="inputDrawerName" placeholder="輸入抽屜名稱"></b-form-input>
      </div>
    </WcBottomModal>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import commonBusyAndErrorHandling from '@/assets/js/commonBusyAndErrorHandling.js';
import ClothCardList from '@/components/clothList/ClothCardList.vue';
import ClothCategoryTabs from '@/components/clothList/ClothCategoryTabs.vue';
import DrawerSelectBottomModal from '@/components/drawer/DrawerSelectBottomModal.vue';
import WcCommonModal from '@/components/commons/WcCommonModal.vue';
import WcBottomModal from '@/components/commons/WcBottomModal.vue';
import DrawerImportModal from '@/components/drawer/DrawerImportModal';

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'ClosetDrawerContentPage',
  data() {
    return {
      init: false,
      drawerSerial: -1,
      drawer: {},

      selectedClothIds: [],
      sortType: 'category',
      sortDirectionDesc: false,
      blockShowText: false,
      clothListMode: 'view',

      inputDrawerName: '',

      // filter
      fillCategory1: -1,
      filterPublic: -1,
      filterTags: [],
      filterColors: [],

      optModalActions: [
        {
          text: '變更抽屜名稱',
          value: 'edit'
        },
        {
          text: '刪除抽屜',
          value: 'delete'
        }
      ],

      showDrawerImportModal: false,
      showMoveToModal: false,
      showOptModal: false,
      showDeleteConfirmModal: false,
      showChangeNameModal: false,
    };
  },
  props: {
  },
  components: {
    ClothCardList,
    ClothCategoryTabs,
    DrawerSelectBottomModal,
    WcCommonModal,
    WcBottomModal,
    DrawerImportModal,
  },
  computed: {
    ...mapState(['user', 'cloths', 'clothCategories']),
    ...mapGetters(['isTester']),
    drawerName() {
      return this.drawer.name;
    },
    clothInDrawer() {
      const cs = this.cloths.filter((c) => {
        return !c.isDeleted && c.recycleType === -1 && c.drawerSerial === this.drawer.serial;
      });
      return cs;
    },
    importModalCloths() {
      return this.cloths.filter((c) => {
        return !c.isDeleted && c.recycleType === -1 && c.drawerSerial === -1;
      });
    },
    filters() {
      const filter = [];
      if (this.fillCategory1 !== -1) {
        filter.push({
          type: 'category1',
          value: this.fillCategory1
        });
      }
      if (this.filterTags.length > 0) {
        filter.push({
          type: 'tags',
          value: this.filterTags
        });
      }
      if (this.filterColors.length > 0) {
        filter.push({
          type: 'color',
          value: this.filterColors,
        });
      }
      if (this.filterPublic !== -1) {
        filter.push({
          type: 'isPublic',
          value: this.filterPublic === 1,
        });
      }
      return filter;
    },
    clothInUseDataLength() {
      const dataLength = [this.clothInDrawer.length];
      for (const c of this.clothCategories) {
        const length = this.clothInDrawer.filter((cloth) => {
          return cloth.category1 === c.serial;
        }).length;
        dataLength.push(length);
      }
      return dataLength;
    },
    hasCloth() {
      return this.clothInDrawer.length > 0;
    },
    showToolsDiv() {
      return this.clothListMode === 'view';
    },
    showExportConfirmDiv() {
      return this.clothListMode === 'select';
    },
    changeNameDisabled() {
      const t = this.inputDrawerName.trim().length;
      return t === 0 || t > 10;
    }
  },
  mounted() {
    try {
      const drawerSerial = parseInt(this.$route.params.serial);
      if (drawerSerial && !isNaN(drawerSerial)) {
        this.drawerSerial = drawerSerial;
      } else {
        throw new Error('讀取抽屜序號失敗');
      }
      this.handleAsyncTask(async () => {
        const drawer = await this.$store.dispatch('api/getDrawerInfoPromise', this.drawerSerial);
        this.drawer = Object.assign({}, drawer);
        this.init = true;
      });
      
    } catch (error) {
      console.error(error);
      this.errorRedirect();
    }
  },
  methods: {
    ...mapActions(['showMsgModal', 'appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg', 'updateCloth', 'refreshCloths']),
    ...mapActions('cloth', ['setClothData', 'openClothManager']),
    errorRedirect() {
      this.$router.push({name: 'ClosetDrawerList'});
    },
    setCategoryFilter(category) {
      this.fillCategory1 = category.value;
    },
    async clothClicked(cloth) {
      if (this.clothListMode === 'select') {
        const index = this.selectedClothIds.indexOf(cloth.serial);
        if (index === -1) {
          console.log('not found');
          this.selectedClothIds.push(cloth.serial);
        } else {
          console.log('found');
          this.selectedClothIds.splice(index, 1);
        }
      } else {
        const defaultObj = {
          clothId: cloth.serial,
          clothType: 'view',
          clothImgUrl: '',
        };
        await this.setClothData(defaultObj);
        this.openClothManager();
      }
    },
    importBtnClicked() {
      this.openImportModal();
    },
    openImportModal() {
      this.showDrawerImportModal = true;
    },
    closeImportModal() {
      this.showDrawerImportModal = false;
    },
    clothMoved(cloths) {
      this.closeImportModal();
      this.showMsgModal(`將 ${cloths.length} 件衣服收進抽屜中`);
    },
    exportBtnClicked() {
      if (this.hasCloth) {
        this.clothListMode = 'select';
      }
    },
    optAction(action) {
      if (action === 'delete') {
        this.optDeleteClicked();
      } else if (action === 'edit') {
        this.optEditClicked();
      }
    },
    optDeleteClicked() {
      this.closeOptModal();
      this.openDeleteConfirmModal();
    },
    optEditClicked() {
      this.closeOptModal();
      this.openChangeNameModal();
    },
    openDeleteConfirmModal() {
      this.showDeleteConfirmModal = true;
    },
    closeDeleteConfirmModal() {
      this.showDeleteConfirmModal = false;
    },
    deleteDrawer() {
      this.handleAsyncTask(async () => {
        await this.$store.dispatch('api/postDrawerDeletePromise', this.drawer.serial);
        this.refreshCloths();
        this.closeDeleteConfirmModal();
        this.$router.push({name: 'ClosetDrawerList'});
      });
    },
    openChangeNameModal() {
      this.inputDrawerName = this.drawerName;
      this.showChangeNameModal = true;
    },
    closeChangeNameModal() {
      this.showChangeNameModal = false;
    },
    editDrawer() {
      this.handleAsyncTask(async () => {
        const name = this.inputDrawerName.trim();
        const drawer = await this.$store.dispatch('api/postDrawerUpdatePromise', {
          serial: this.drawer.serial,
          name,
        });
        this.$emit('updated', drawer);
        this.closeChangeNameModal();
        this.showMsgModal(`已將抽屜更名為【${drawer.name}】`);
        this.drawer.name = drawer.name;
      });      
    },
    exportCancelBtnClicked() {
      this.clothListMode = 'view';
      this.selectedClothIds.splice(0);
    },
    exportConfirmBtnClicked() {
      if (this.selectedClothIds.length > 0) {
        this.showMoveToModal = true;
      } else {
        console.log('沒有選擇的單品');
      }
    },
    closeMoveToModal() {
      this.showMoveToModal = false;
    },
    moveCloths(drawerSerial) {
      this.handleAsyncTask(async () => {
        try {
          let list = [];
          if (drawerSerial === -1) {
            list = await this.$store.dispatch('api/postRemoveFromDrawerPromise', this.selectedClothIds);
          } else {
            list = await this.$store.dispatch('api/postDrawerMoveIntoPromise', {
              to: drawerSerial,
              cloths: this.selectedClothIds
            });
          }
          for (const c of list) {
            this.updateCloth(c);
          }
          this.showMsgModal(`已移動 ${this.selectedClothIds.length} 件衣服`);
          this.closeMoveToModal();
          this.exportCancelBtnClicked();
        } catch (error) {
          this.appendErrorMsg(error);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.drawer-content-page {
  .header-nav {
    position: sticky;
    top: 0;
    background-color: #fff;
    padding: .5rem 0;
    z-index: 10;
    .back-to-list-link {
      // display: none;
    }

    .drawer-name {
      font-size: 1.2em;
      font-weight: 600;
    }
    ::v-deep .dropdown.b-dropdown.btn-group {
      >button {
        padding: 0;
      }
    }
  }

  .body-cloths {
    padding-bottom: 3rem;
    position: relative;

    .empty-msg {
      position: relative;
      height: 50vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      row-gap: 1rem;
    }
    .export-confirm-div {
      position: fixed;
      bottom: 5.5rem;
      left: 50%;
      transform: translate(-50%, 0);
      border-radius: 999px;
      background-color: #fff;
      box-shadow: 0 4px 12px 0px $typography-secondary-default;
      padding: 0 4px;
      .confirm-btn {

      }
      &.selection-empty {
        .confirm-btn {
          opacity: .6;
        }
      }
      button {
        border: none;
        background-color: transparent;
        padding: 8px 12px; 
        &:not(:first-child) {
          border-left: solid 1px $typography-secondary-default;
        }
      }
      
      .cancel-btn {

      }
    }
  }
}
</style>